import React, { useState, useEffect, forwardRef } from "react";
import "i18next";
import { useTranslation } from "react-i18next";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
  styled,
} from "@mui/material";

import Slide from "@mui/material/Slide";
import WarningIcon from "@mui/icons-material/Warning";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const CustomButton = styled(Button)(() => ({
  fontFamily: "Urbanist, Verdana, Arial, sans-serif",
  fontSize: "12px",
  letterSpacing: "0.10em",
  borderRadius: "8px",
  fontWeight: "600",
  textTransform: "none",
  color: "white",
  marginTop: "-10px",
  backgroundColor: "#3299FF",
  "&:hover": {
    backgroundColor: "#2878CC",
  },
}));
const CustomOutlinedButton = styled(Button)(() => ({
  fontFamily: "Urbanist, Verdana, Arial, sans-serif",
  fontSize: "12px",
  letterSpacing: "0.10em",
  borderRadius: "8px",
  fontWeight: "600",
  textTransform: "none",
  borderColor: "#3299FF",
  color: "#3299FF",
  marginTop: "-10px",
  "&:hover": {
    borderColor: "#3299FF",
    backgroundColor: "#E0F2FF",
  },
}));

export default function DialogBoxuUnsavedChanges(props) {
  const { t } = useTranslation(["BulkEditDialogBox"]);
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState("");

  const handleClose = () => {
    setOpen(false);
    props.handleCancel(props.cancelOption);
    props.dialogBoxReset();
  };
  const handleProceed = () => {
    setOpen(false);
    props.handleProceed(props.proceedOption);
    props.dialogBoxReset();
  };

  useEffect(() => {
    if (props.dialog.open) {
      setMessage(props.dialog.message);
      setOpen(true);
    }
  }, [props.dialog.open]);
  return (
    <div>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle
          id="alert-dialog-slide-title"
          sx={{
            fontFamily: "Urbanist, Arial, sans-serif",
            fontSize: "1.5rem",
            fontWeight: "bold",
            letterSpacing: "0.10em",
            textAlign: "center",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            color: "#0288d1",
          }}
        >
          <WarningIcon
            sx={{
              color: "#ff9800",
              fontSize: "2rem",
              width: 60,
              height: 60,
              marginBottom: 1,
            }}
          />
          <span style={{ lineHeight: 1 }}>{t("WARNING")}</span>
        </DialogTitle>
        <DialogContent
          sx={{
            textAlign: "center",
            "& ul": {
              textAlign: "left",
            },
          }}
        >
          <DialogContentText
            id="alert-dialog-slide-description"
            sx={{
              fontFamily: "Urbanist, Arial, sans-serif",
              fontSize: "1.2rem",
              letterSpacing: "0.10em",
            }}
          >
            {message}
            {/* {t("message")} */}
          </DialogContentText>
        </DialogContent>
        <DialogActions
          sx={{
            justifyContent: "center",
            "& > :not(:last-of-type)": {
              marginRight: "16px",
            },
            paddingBottom: "24px",
          }}
        >
          <CustomOutlinedButton variant="outlined" onClick={handleClose}>
            {t("Stay")}
          </CustomOutlinedButton>
          <CustomButton onClick={handleProceed}>{t("Proceed")}</CustomButton>
        </DialogActions>
      </Dialog>
    </div>
  );
}
